import React, { useState, useEffect } from "react";
import styles from "./UserManage.styles";
import CustomToast from "../../components/CustomToast.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { updateUser, getUserDetail } from "../../utils/api/user";
import { useParams } from "react-router-dom";

function EditUser() {
  const { id } = useParams();
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [fields, setFields] = useState({
    id: id,
    role: "",
    first_name: "",
    last_name: "",
    username: "",
    area_code: "",
    daily_quota: "0",
  });

  useEffect(() => {
    const fetchUserData = async () => {
      const response = await getUserDetail(id);
      if (response?.data?.data?.messages?.error) {
        setMessage({
          message: response.data.data.messages.error,
          type: "danger",
        });
        setShowToast(true);
        setDisabled(false);
        return;
      }

      setFields({
        id: id,
        role: response.data.data[0].role,
        first_name: response.data.data[0].first_name,
        last_name: response.data.data[0].last_name,
        username: response.data.data[0].username,
        area_code: response.data.data[0].area_code,
        daily_quota: response.data.data[0].daily_quota || 0,
      });
    };

    fetchUserData();
  }, [id]);

  const handleFields = async () => {
    setDisabled(true);

    if (fields.role === "") {
      setMessage({ message: "Please select a role", type: "danger" });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    if (fields.first_name === "") {
      setMessage({ message: "Please enter your first name", type: "danger" });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    if (fields.last_name === "") {
      setMessage({ message: "Please enter your last name", type: "danger" });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    // contains number only
    if (
      fields.username === "" ||
      fields.username.length !== 11 ||
      !fields.username.match(/^[0-9]*$/)
    ) {
      setMessage({
        message: "Please enter a proper Mobile Number (11 digits)",
        type: "danger",
      });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    if (
      fields.area_code === "" ||
      fields.area_code.length !== 6 ||
      !fields.area_code.match(/^[0-9]*$/)
    ) {
      setMessage({
        message: "Please enter a proper area code",
        type: "danger",
      });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    if (
      fields.daily_quota === "" ||
      !fields.daily_quota.match(/^[0-9.]*$/) ||
      parseFloat(fields.daily_quota) < 0
    ) {
      setMessage({
        message: "Please enter a proper daily quota",
        type: "danger",
      });
      setShowToast(true);
      setDisabled(false);
      return;
    }

    const response = await updateUser(fields);
    if (!response?.data?.data?.messages?.error) {
      setMessage({ message: "User Updated Successfully", type: "success" });
      // Redirect to dashboard after 1 second
      setTimeout(() => {
        window.location.href = "/user";
      }, 1000);
    } else {
      setMessage({
        message: response?.data?.data?.messages?.error,
        type: "error",
      });
    }

    setDisabled(false);
    setShowToast(true);
  };

  const handleMobileNumber = (number) => {
    // check if it is a valid number
    if (number.match(/^[0-9]*$/) && number.length <= 11) {
      setFields({ ...fields, username: number });
    }
  };

  const handleAreaCode = (code) => {
    // check if it is a valid number
    if (code.match(/^[0-9]*$/) && code.length <= 6) {
      setFields({ ...fields, area_code: code });
    }
  };

  const handleDailyQuota = (quota) => {
    // check if it is a valid number
    if (quota.match(/^[0-9]*$/)) {
      setFields({ ...fields, daily_quota: quota });
    }
  };

  return (
    <div className='container-fluid'>
      <div className='row mt-4'>
        <div className='col-md-12'>
          <p className='h1 title text-center'>EDIT USER</p>
        </div>
      </div>
      <div className='row justify-content-center'>
        <div col='12' className='col-md-5'>
          <div className='card text-dark my-2 mx-auto'>
            <div className='card-body'>
              {/* EditUser logo */}
              <div className='row justify-content-center'>
                <FontAwesomeIcon
                  icon={faUser}
                  className='mr-2'
                  style={{ fontSize: 50, color: "#f26520" }}
                />
              </div>
              <div className='col-12 mt-2'>
                <select
                  className='form-select mb-3 w-100'
                  value={fields.role}
                  style={{ height: 60 }}
                  onChange={(e) =>
                    setFields({ ...fields, role: e.target.value })
                  }
                >
                  <option value=''>Select Role</option>
                  <option value='Admin'>Admin</option>
                  <option value='Staff'>Staff</option>
                </select>
              </div>

              <div className='col-12'>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    id='floatingInput'
                    className='form-control mb-3 w-100 text-dark'
                    placeholder='First Name'
                    style={styles.input}
                    value={fields.first_name}
                    onChange={(e) =>
                      setFields({ ...fields, first_name: e.target.value })
                    }
                  />
                  <label htmlFor='floatingInput'>First Name</label>
                </div>
              </div>

              <div className='col-12'>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    id='floatingInput'
                    className='form-control mb-3 w-100 text-dark'
                    placeholder='Last Name'
                    style={styles.input}
                    value={fields.last_name}
                    onChange={(e) =>
                      setFields({ ...fields, last_name: e.target.value })
                    }
                  />
                  <label htmlFor='floatingInput'>Last Name</label>
                </div>
              </div>

              <div className='col-12'>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    id='floatingInput'
                    className='form-control mb-3 w-100 text-dark'
                    placeholder='Username'
                    style={styles.input}
                    value={fields.username}
                    onChange={(e) => handleMobileNumber(e.target.value)}
                  />
                  <label htmlFor='floatingInput'>Mobile Number</label>
                </div>
              </div>

              <div className='col-12'>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    id='floatingInput'
                    className='form-control mb-3 w-100 text-dark'
                    placeholder='Mobile Number'
                    style={styles.input}
                    value={fields.area_code}
                    onChange={(e) => handleAreaCode(e.target.value)}
                  />
                  <label htmlFor='floatingInput'>Area Code</label>
                </div>
              </div>

              <div className='col-12'>
                <div className='form-floating mb-3'>
                  <input
                    type='text'
                    id='floatingInput'
                    className='form-control mb-3 w-100 text-dark'
                    placeholder='Daily Quota'
                    style={styles.input}
                    value={fields.daily_quota}
                    onChange={(e) => handleDailyQuota(e.target.value)}
                  />
                  <label htmlFor='floatingInput'>Daily Quota</label>
                </div>
              </div>

              <button
                className='btn btn-lg btn-block'
                style={styles.button}
                type='submit'
                onClick={handleFields}
                disabled={disabled}
              >
                {disabled ? "Please wait..." : "Update User"}
              </button>

              <button
                className='btn btn-lg btn-block text-dark'
                style={styles.button}
                type='submit'
                onClick={() => (window.location.href = "/user")}
                ref={(el) =>
                  el &&
                  el.style.setProperty(
                    "background-color",
                    "#d5d5d5",
                    "important"
                  )
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <CustomToast
        type={details.type}
        message={details.message}
        title='Edit User'
        show={showToast}
        setShow={setShowToast}
      />
    </div>
  );
}

export default EditUser;
